import { SFCCBasket } from '../../../models/sfcc-basket';
import { makeCurrentBasketAction } from '../../../utilities/make-current-basket-action';
import { shopHttp } from '../../basket-api';

export const removeCoupon = async (
  couponItemId: string,
  ensureBasketMethod: () => Promise<SFCCBasket>
): Promise<SFCCBasket> => {
  return await makeCurrentBasketAction(
    `coupons/${couponItemId}`,
    removeCouponFromBasket,
    ensureBasketMethod
  );
};

const removeCouponFromBasket = async (requestPath: string): Promise<SFCCBasket> => {
  const response = await shopHttp.delete<SFCCBasket>(requestPath);

  return response.data;
};
